import React, { FC, useEffect } from 'react';

import { map } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

import { ECRImageContainersComponent } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Summary/ECR/Components/ECRImageContainersComponent';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';
import { actions } from 'containers/ActiveCloudResource/slice';

interface Props {
  isOpen: boolean;
  onClose();
  row: any;
}

export const ECRImageContainers: FC<Props> = props => {
  const { isOpen, row } = props;
  const { ecrImages } = useSelector(selectActiveResource);
  const { ecrImageContainers, containerRiskContext } = ecrImages;

  const dispatch = useDispatch();

  useEffect(() => {
    isOpen &&
      dispatch(
        actions.getECRImageContainers({
          q: {
            getContainersRequest: {
              //image_names: [row?.uri],
              repository_uri: row?.repository_uri,
              image_digest: row?.image_digest,
            },
          },
          onSuccess: res => {
            dispatch(
              actions.getContainerRiskContext({
                q: {
                  riskContextRequest: {
                    uuids: map(res, o => o?.resource_uuid!),
                  },
                },
              }),
            );
          },
        }),
      );
  }, [dispatch, isOpen, row]);

  return (
    <ECRImageContainersComponent
      {...props}
      containerRiskContext={containerRiskContext}
      ecrImageContainers={ecrImageContainers}
    />
  );
};
